import React from 'react';
import '../../styles/site/FeaturesSection.css';

// Componente para cada recurso individual
const FeatureCard = ({ title, description, icon }) => {
  return (
    <div className="feature-card">
      <div className="feature-icon">
        <i className={icon}></i>
      </div>
      <h3 className="feature-title">{title}</h3>
      <p className="feature-description">{description}</p>
    </div>
  );
};

// Componente principal que renderiza uma grade de recursos
const FeaturesSection = ({ features, title }) => {
  return (
    <section className="features-section">
      {title && (
        <div className="section-header">
          <h2 className="section-title">{title}</h2>
          <div className="divider">
            <span className="star-divider">✧</span>
          </div>
        </div>
      )}
      
      <div className="features-grid">
        {features.map(feature => (
          <FeatureCard
            key={feature.id}
            title={feature.title}
            description={feature.description}
            icon={feature.icon}
          />
        ))}
      </div>
    </section>
  );
};

export default FeaturesSection;